import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CAREER_WORKSPACE_PREVIEW, type CareerWorkspacePreviewCopy } from './careerWorkspacePreviewCopy';

export function useCareerWorkspacePreviewCopy(): CareerWorkspacePreviewCopy {
  const { t, i18n } = useTranslation();

  return useMemo(() => {
    const entries = (Object.keys(CAREER_WORKSPACE_PREVIEW) as (keyof typeof CAREER_WORKSPACE_PREVIEW)[]).map(
      (key) => [key, t(`home.careerWorkspacePreview.${key}`, { defaultValue: CAREER_WORKSPACE_PREVIEW[key] })],
    );
    return Object.fromEntries(entries) as CareerWorkspacePreviewCopy;
  }, [t, i18n.language]);
}
